export function buildWaistcoatBlocks(generated = {}) {
  return [
    { key: 'front', label: 'Front', path: generated.frontPath || '', enabled: Boolean(generated.frontPath) },
    { key: 'back', label: 'Back', path: generated.backPath || '', enabled: Boolean(generated.backPath) },
  ];
}
